import { useEffect, useRef, useState } from 'react'
import { FaAngleDown } from 'react-icons/fa'
import { useLocation } from 'react-router-dom'
import { PrimaryButton } from '../../molecules/Button'

const plans = [

    {
        title: "Basic",
        subtitle: "Sufficient for one retail shop",
        monthlyCost: "GH₵ 149.99",
        annualCost: "GH₵ 1499.99",
        features: [
            "Track sales", 
            "Track income and expenses", 
            "Generate invoices", 
            "Accounting features",
            "Inventory Management"
        ]
    },
    {
        title: "Essentials",
        subtitle: "Sufficient for managing multiple retail shops",
        monthlyCost: "GH₵ 299.99",
        annualCost: "GH₵ 2999.99",
        features: [
            "All basic features included",
            "Advanced accounting features",
            "Advanced inventory management",
            "User activity logs",
            "Keep track of your shopkeeper's performance",
            "Generate invoices", 
            "Export inventory, logs, user and sales history", 
        ]
    },
    {
        title: "Enterprise",
        subtitle: "Custom features to fit all your business needs",
        monthlyCost: "Call us",
        annualCost: "Call us",
        features: []
    },

]

export default function PlanSection() {

    const [duration, setDuration] = useState<"monthly"|"annual">("monthly")
    const planSectionRef = useRef<HTMLDivElement>(null)
    const currentLocation = useLocation()

    useEffect(()=>{
        if(currentLocation.hash === "#pricing"){
            planSectionRef?.current?.scrollIntoView()
        }
    },[currentLocation.hash])

    const handleOnDurationToggled = ()=>{
        setDuration(duration === "monthly" ? "annual" : "monthly")
    }

    return (
        <section className='p-24 md:px-0 flex flex-col items-center' ref={planSectionRef}>
            
            <div className='w-3/5 md:w-4/5 mb-3'>
                <h5 className="text-3xl font-bold text-primary text-center">
                    Choose the plan that fits your retail size
                </h5>
                <p></p>
            </div>

            <div className='flex items-center my-12' >
                <h5 
                    className={duration === "monthly" ? "font-semibold text-primary text-xl relative before:content-[''] before:block before:absolute before:-bottom-2 before:w-full before:h-1 before:bg-primary/30 before:rounded" : "font-semibold text-neutral-500 text-xl"}
                >
                    Monthly
                </h5>
                <div className="mx-5">
                    <ToggleBtn active={duration} handleOnToggle={handleOnDurationToggled} />
                </div>
                <h5 className={duration === "annual" ? "font-semibold text-primary text-xl before:content-[''] before:block before:absolute before:-bottom-2 before:w-full before:h-1 before:bg-primary/30 before:rounded" : "font-semibold text-neutral-500 text-xl"}>Annual</h5>
            </div>

            <div className="flex sm:flex-col justify-between items-start w-10/12">

                {
                    plans.map((plan, index)=>(
                        <div 
                            key={index} 
                            style={{boxShadow: "0 0.125rem 0.5rem 0 rgb(0 0 0 / 20%)"}} 
                            className="py-10 px-3 rounded-3 w-32% sm:w-full sm:mb-6 rounded border-black"
                        >
                            <div>
                                <h5 className="font-medium text-xl text-primary">
                                    {plan.title}
                                </h5>
                                <div className='items-center inline-flex justify-center mt-2'>
                                    <div className="w-10 h-0.5 bg-secondary  inline-block"/>
                                    <div className="w-2 h-0.5 bg-secondary ml-2 inline-block justify-self-center"></div>
                                </div>
                            </div>
                            <p className="text-sm text-graphite my-5">
                                {plan.subtitle}
                            </p>

                            <h5 className="text-3xl font-extrabold text-primary">
                                {duration === "monthly" ? plan.monthlyCost : plan.annualCost}
                            </h5>

                            <div className='my-7 w-1/2'>
                                <PrimaryButton>
                                    Get started
                                </PrimaryButton>
                            </div>
                            <div className='mt-7'>
                                {
                                    plan.features.map((feature, index)=>(
                                        <div key={index} className="flex mb-5">
                                            <FaAngleDown size={18} color='#404040' /> <span className="text-graphite text sm">{feature}</span>
                                        </div>
                                    ))
                                }
                            </div>

                        </div>
                    ))
                }
                
            </div>

            

        </section>
    )
}

function ToggleBtn({active, handleOnToggle}:{active: "monthly"|"annual", handleOnToggle:()=>void}){

    return(
        <div className="w-20 h-10 bg-primary rounded-3xl border-2 p-1">

            <div 
                className={active === 'monthly' ? 'rounded-full w-1/2 h-full bg-secondary duration-300' : 'rounded-full w-1/2 h-full bg-secondary translate-x-full duration-300'} 
            />
            <input 
                type="checkbox"
                className='w-full h-full absolute top-0 left-0 opacity-0'
                onChange={handleOnToggle}
                />
            
        </div>
    )

}
